import React from 'react';
import { Link } from 'gatsby';

import { Row } from '../../../atoms/row/Row';
import { CompareArrows } from '../../../../../static/icons/compareArrows';

export const CompareItem = ({
  logoOneUrl,
  logoOneAlt,
  logoTwoUrl,
  logoTwoAlt,
  compareUrl,
}) => (
  <Link
    to={compareUrl}
    className="flex flex-row gap-1 flex-1 w-full min-w-[300px] max-w-md bg-white max-h-20 rounded-3xl px-10 py-4 border-l-[15px] border-secondary-400"
  >
    <Row className="flex-1 justify-between">
      <img
        src={logoOneUrl}
        alt={logoOneAlt ?? ''}
        width="96"
        height="48"
        loading="lazy"
      />
      <CompareArrows />
      <img
        src={logoTwoUrl}
        alt={logoTwoAlt ?? ''}
        width="96"
        height="48"
        loading="lazy"
      />
    </Row>
  </Link>
);
